<h3 class="trustbox-slider-heading">
  We’ve helped millions of happy customers get back on track
</h3>
<sales-trustbox
  [trustBoxType]="TrustBox.SLIDER"
  [tagsFilter]="tagsFilter"
></sales-trustbox>
